import axios, { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import { toast } from '@/components/ui/toast/use-toast';
import { env } from '@/vite-env';

// Create a fresh instance for web
const apiClient = axios.create({
  baseURL: env?.API_URL,
  withCredentials: true,
});

// Add request interceptor for web
apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers = new AxiosHeaders(config.headers);

  if (!config.headers.get('Accept')) {
    config.headers.set('Accept', 'application/json');
  }

  return config;
});

// Add response interceptor for web
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const { response } = error;

    if (response) {
      if (response.status === 401 || response.status === 403) {
        // get the current page to redirect back to after login
        const currentPath = window.location.pathname + window.location.search;

        // don't redirect to login or logout pages themselves
        const shouldRedirectBack = !currentPath.startsWith('/login') && !currentPath.startsWith('/logout');

        // build the logout URL with redirect parameters
        let logoutUrl = '/logout';
        if (shouldRedirectBack) {
          logoutUrl += `?redirectTo=${encodeURIComponent(currentPath)}`;
        }

        window.location.href = logoutUrl;
      } else if (response.status === 404) {
        window.location.href = '/not-found';
      } else if (response.status === 400) {
        return Promise.reject(response.data);
      } else {
        toast({
          title: 'Server Error',
          description: 'An error has occurred',
        });
      }
    }

    return Promise.reject(error);
  },
);

export { apiClient };
